import AddSearchClient from 'addsearch-js-client';
import { addSearchSiteKey } from './initialization.js';

export const getAddSearchClient = (id) => {
	const el = document.getElementById(id);
	if (el) {
		let client = new AddSearchClient(addSearchSiteKey);

		// Filters
		client.setFilterObject(JSON.parse(el.getAttribute('data-filters')));

		// Language
		const lang = el.getAttribute('data-language');
		if (lang) {
			client.setLanguage(lang);
		}

		// Fuzzy Matching
		const fuzzyMatching = el.getAttribute('data-fuzzy-matching');
		const fuzzyMatchingType = fuzzyMatching === 'true' ? true : fuzzyMatching === 'false' ? false : fuzzyMatching;
		client.setFuzzyMatch(fuzzyMatchingType);

		// Paging
		const resultCount = el.getAttribute('data-result-count');
		if (resultCount) {
			client.setPaging('1', resultCount, 'relevance', 'desc');
		}

		return client;
	} else {
		throw new Error(`Failed to create the addSearchClient for element with ID ${id}`);
	}
};
